// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import React from 'react';
import CaretDownOutlinedSvg from "@ant-design/icons-svg/es/asn/CaretDownOutlined";
import AntdIcon from '../components/AntdIcon';

var CaretDownOutlined = function CaretDownOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CaretDownOutlinedSvg
  }));
};

CaretDownOutlined.displayName = 'CaretDownOutlined';
export default React.forwardRef(CaretDownOutlined);